import { AvatarWithLabel, Box } from '@pocketlaw/tetris';
export function Setting(props) {
    const { icon, label, description, endElement, children } = props;
    return (<Box flexDirection="column">
      <Box alignItems="center" justifyContent="space-between" p="sm">
        <AvatarWithLabel size="md" appearance="light" title={label} subtitle={description}>
          {icon}
        </AvatarWithLabel>
        {endElement}
      </Box>
      {children}
    </Box>);
}
